import React, { useState } from 'react'
import PropTypes from 'prop-types'
import reactCSS from 'reactcss'
import { SketchPicker } from 'react-color'

function ColorPicker(props) {
  const { color, getColor, children } = props
  const [displayColorPicker, setDisplayColorPicker] = useState(false)
  const [myColor, setMyColor] = useState(color)
  const styles = reactCSS({
    default: {
      color: {
        margin: '0px',
        padding: '0px',
        width: '15px',
        height: '15px',
        background: `rgba(${myColor.r}, ${myColor.g}, ${myColor.b}, 1)`,
      },
      swatch: {
        marginTop: '5px',
        padding: '0px',
        background: '#fff',
        borderRadius: '1px',
        border: ' 1px solid black',
        boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
        display: 'inline-block',
        cursor: 'pointer',
      },
      popover: {
        position: 'absolute',
        zIndex: '2',
      },
      cover: {
        position: 'fixed',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px',
      },
    },
  })

  const handleClick = () => {
    setDisplayColorPicker((prevDisplayColorPicker) => !prevDisplayColorPicker)
  }

  const handleClose = () => {
    setDisplayColorPicker(false)
  }

  const handleChange = (color) => {
    const selectedColor = color.rgb
    setMyColor({
      r: selectedColor.r,
      g: selectedColor.g,
      b: selectedColor.b,
    })
    getColor(selectedColor)
  }

  return (
    <div>
      {children ? (
        <div onClick={handleClick}>{children}</div>
      ) : (
        <div style={styles.swatch} onClick={handleClick}>
          <div style={styles.color} />
        </div>
      )}
      {displayColorPicker ? (
        <div style={styles.popover}>
          <div style={styles.cover} onClick={handleClose} />
          <SketchPicker color={{ ...myColor, a: 1 }} onChange={handleChange} />
        </div>
      ) : null}
    </div>
  )
}

ColorPicker.propTypes = {
  color: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  getColor: PropTypes.func.isRequired,
  children: PropTypes.element,
}

export default ColorPicker
